import { render, staticRenderFns } from "./premiumCalcSitecore.vue?vue&type=template&id=597dea46"
import script from "./premiumCalcSitecore.vue?vue&type=script&lang=js"
export * from "./premiumCalcSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports